import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'zip-selector',
  templateUrl: './zip-code.component.html',
  styleUrls: ['./zip-code.component.scss']
})
export class ZipCodeComponent implements OnInit {

  @Input() label: any = 'Zip/Postal Code';
  @Input() isRequired: any = false;
  @Input() appearance: any = 'outline';
  @Input() customClass: any = 'col';
  @Input() model: any = '';
  @Input() placeholder: any = 'Enter Zip';
  @Input() search_canada: any = 0;
  @Input() not_found = 'No Result Found';
  @Input() defaultzip: any = '';
  @Input() disabled: any = false;
  @Input() value: any = '';
  @Input() t: any = '1';
  zipArray: any = [];
  loader = false;
  show_options: boolean;

  @Output() zipSelected = new EventEmitter();
  // @Output() removeZipCode = new EventEmitter();
  zipObj: any;

  constructor(
    public mainService: MainService,
    public cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.defaultzip && this.defaultzip['zip']) {
      this.zipObj = this.defaultzip;
      this.zipArray = [this.defaultzip];
      this.zipSelected.emit(this.defaultzip);
    }
    window.addEventListener('scroll', this.scrollEvent, true);
    window.addEventListener('click', (e) => {
      if (this.show_options) {
        this.show_options = false;
      }
    });
  }
  scrollEvent = (event: any): void => {
    // if (this.autoComplete.panelOpen)
    //   // this.autoComplete.closePanel();
    //   this.autoComplete.updatePosition();
  }

  getZip(value: any, search_canada?: any) {
    this.loader = true;
    if (value && (value.length < 4 || value.length > 6)) {
      this.loader = false;
      return false;
    }
    this.mainService.getZipcode({
      zipcode: value,
      hideLoader: true,
      search_canada: Number(search_canada) === 1 ? search_canada : 0
    }
    ).subscribe((data: any) => {
      if (data && Number(data.is_error) === 0) {
        this.zipArray = data.zip_info;
      } else {
        this.zipArray = [];
      }
      this.loader = false;
    });
  }

  onSelectZip(data: any) {
    this.zipObj = data;
    this.zipSelected.emit(data);
    this.show_options = false;
    this.zipArray = [];
  }

  removeZipCode() {
    this.show_options = true;
    this.zipArray = [];
    this.zipObj = '';
    this.model = '';
    this.zipSelected.emit('');
  }

  checkIfSelected(event) {
    if (!this.zipObj) {
      this.model = '';
    } else {
      // tslint:disable-next-line:triple-equals
      if (this.zipObj.zip != this.model) {
        this.model = this.zipObj.zip;
      }
    }

    this.cd.detectChanges();
  }

  omit_special_char(e) {
    this.show_options = true;
    let k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || Number(k) === 8 || Number(k) === 32 || (k >= 48 && k <= 57));
  }

  inputEvent(e) {
    // if (e.target.value.length > 5) {
    //   return false;
    // }
    // return true
  }


}
